import React from 'react'
import ReactDOM from 'react-dom'
import { ApolloProvider } from 'react-apollo'
import createBrowserHistory from 'history/createBrowserHistory'
import { autorun } from 'mobx'
import { Provider } from 'mobx-react'
import routerSync from '~/utils/routerSync'
// import { syncHistoryWithStore } from 'mobx-react-router'
import { Router, Switch, Route, Redirect } from 'react-router-dom'
import { LocaleProvider } from 'antd'
import thTH from 'antd/lib/locale-provider/th_TH'
import '~/index.css'
// import routingStore from '~/stores/routing'
import viewStore from '~/stores/view'
import dataStore from '~/stores/data'
import userStore from '~/stores/user'
// import userPoiStore from '~/stores/userPoi'
import apolloClient from '~/apollo-client'
import App from './App'

// import user from '~/user.json'
// import moment from 'moment'
// moment.tz.setDefault('Asia/Bangkok')

const browserHistory = createBrowserHistory()

const stores = {
  view: viewStore,
  // routing: routingStore,
  data: dataStore,
  user: userStore
}

// userPoiStore.addPOIs(JSON.parse(localStorage.getItem('userPOIs')))

const history = routerSync({ store: viewStore, history: browserHistory })
// const history = syncHistoryWithStore(browserHistory, routingStore)
autorun(() => {
  // TODO: if scenario && scenarioId fetch from scenario
  if (viewStore.catchmentId) {
    dataStore.fetchCatchmentStations(viewStore.catchmentId)
  }
})

autorun(() => {
  if (userStore.profile && userStore.profile.userId) {
    dataStore.fetchPois(userStore.profile.userId)
  }
  // localStorage.setItem('userPOIs', JSON.stringify(userPoiStore.items))
})

autorun(() => {
  if (viewStore.scenarioIds.length > -1) {
    dataStore.fetchScenarios()
  }
  // localStorage.setItem('userPOIs', JSON.stringify(userPoiStore.items))
})

ReactDOM.render(
  <ApolloProvider client={apolloClient} >
    <Provider {...stores} >
      <LocaleProvider locale={thTH}>
        <Router history={history} >
          <Switch>
            <Route exact path='/:mode(monitoring|forecasting|scenario|optimization)' component={App}/>
            <Redirect to='/monitoring'/>
          </Switch>
        </Router>
      </LocaleProvider>
    </Provider>
  </ApolloProvider>,
  document.getElementById('root')
)

// registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js